// extracted by mini-css-extract-plugin
module.exports = {"listRow":"BeneficiaryRow_listRow__lezu_"};